
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Json } from '@/integrations/supabase/types';

export interface AgencyAnalyticsData {
  resumo_geral: AgencyListing[];
  distribuicao_por_tipo: TypeDistribution[];
  distribuicao_por_bairro: NeighborhoodDistribution[];
}

export interface AgencyListing {
  anunciante: string;
  total_anuncios: number;
  valor_total: number;
  total_bairros: number;
  total_tipos: number;
  lista_tipos: string;
  tempo_medio_anuncio: number;
}

export interface TypeDistribution {
  anunciante: string;
  tipo: string;
  quantidade: number;
  valor_total: number;
  percentual: number;
}

export interface NeighborhoodDistribution {
  anunciante: string;
  bairro: string;
  quantidade: number;
  valor_total: number;
  valor_medio: number;
  percentual: number;
}

export const useAgencyAnalytics = () => {
  return useQuery<AgencyAnalyticsData, Error>({
    queryKey: ['agencyAnalytics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('get_real_estate_agencies_analytics');
      
      if (error) throw new Error(error.message);
      
      if (!data) {
        throw new Error('No data returned from analytics function');
      }
      
      // First assert as unknown, then as our expected type
      // This helps TypeScript understand our data structure
      const typedData = data as unknown as AgencyAnalyticsData;
      
      // Validate that the expected properties exist
      if (!typedData.resumo_geral || !typedData.distribuicao_por_tipo || !typedData.distribuicao_por_bairro) {
        console.error('Malformed data received from API:', data);
        throw new Error('Data from API does not match expected format');
      }
      
      return typedData;
    }
  });
};
